import {selPropGen} from "../../Properties/selector/selPropGen";
import {PropID} from "../../Properties/enum/PropID";
import {propDefaultFalse, propDefaultTrue} from "../../Properties/util/PropertiesUtil";

export const V2DataUserConfigDict = {
	enabled: {
		label: 'Kontierungen',
		type: 'boolean',
		defaultValue: false,
		defaultOverrideSelector: selPropGen(PropID.v2DataDefault, propDefaultFalse),
		visibleSelector: selPropGen(PropID.v2DataVis, propDefaultTrue),
		userConfig: {
			color: {
				label: 'Farbe',
				defaultValue: "#3a87ad",
				type: 'color',
				visibleSelector: selPropGen(PropID.v2DataVis, propDefaultTrue),
			},
		},
	},
} as const
